import { render, staticRenderFns } from "./modifiers.vue?vue&type=template&id=71f20574&scoped=true&"
import script from "./modifiers.vue?vue&type=script&lang=js&"
export * from "./modifiers.vue?vue&type=script&lang=js&"
import style0 from "./modifiers.vue?vue&type=style&index=0&id=71f20574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f20574",
  null
  
)

export default component.exports